module.exports = __webpack_public_path__ + "2fd126.png";